import * as React from 'react';
import { DateTimeAccuracy, LocalizedDateTime } from "../LocalizedDateTime";

export const formatDateTime = (value: string) => value
    && value !== "0001-01-01T00:00:00Z" ? <LocalizedDateTime time={value} accuracy={DateTimeAccuracy.Minute} isTooltip={true} />
    : '-';

export const formatNull = value => value
    ? value
    : '-';

export const formatUndefined = value => value !== undefined
    ? value
    : '-';

export const formatCheck = value => value
    ? <i className="fas fa-check text-success"></i>
    : <i className="fas fa-times text-danger"></i>;
